/*
 * Os alertas do chat no menu de notificações:
 *
 * - `canelaChatMention`: "mencionou você em #canal" (o `chat_mention`);
 * - `canelaChatMessage`: "Nova mensagem de chat", da MD (ou do canal em "Para
 *   todas as atividades").
 *
 * O link abre a conversa na mensagem, pela URL da página cheia — o que também
 * funciona numa aba nova e no e-mail.
 */
import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
import { ct } from './flags';
function channelUrl(slug, id) {
  return app.route('canela.chat.channel', {
    slug: slug || '-',
    id
  });
}
export class ChatMentionNotification extends Notification {
  data() {
    return this.attrs.notification.content() || {};
  }
  icon() {
    return 'far fa-message';
  }
  href() {
    const data = this.data();
    const base = channelUrl(data.slug, data.channelId);
    return data.threadId ? `${base}/t/${data.threadId}/${data.messageId}` : `${base}/${data.messageId}`;
  }
  content() {
    const data = this.data();
    const user = this.attrs.notification.fromUser();
    return ct(data.kind === 'user' || !data.kind ? 'notifications.mention' : `notifications.mention_${data.kind}`, {
      username: user ? user.displayName() : '',
      channel: data.channelTitle ? `#${data.channelTitle}` : ct('notifications.direct_message')
    });
  }
  excerpt() {
    return null;
  }
}
export class ChatMessageNotification extends Notification {
  data() {
    return this.attrs.notification.content() || {};
  }
  icon() {
    return 'far fa-message';
  }
  href() {
    const data = this.data();
    return channelUrl(data.slug, data.channelId);
  }
  content() {
    const data = this.data();
    const user = this.attrs.notification.fromUser();
    if (data.isDirect && !data.name) return ct('notifications.direct_message_from', {
      username: user ? user.displayName() : ''
    });
    return ct('notifications.message_in', {
      username: user ? user.displayName() : '',
      channel: data.name ? data.isDirect ? data.name : `#${data.name}` : ''
    });
  }
  excerpt() {
    return null;
  }
}
flarum.reg.add('ramon-canela', 'forum/features/chat/notifications', { ChatMentionNotification: ChatMentionNotification,ChatMessageNotification: ChatMessageNotification, });